<template>
  <div class="logsig_3 flex_start">
    <div class="regsucbg">
      <img src="../../../assets/user/regsucleftbg.png" alt="" />
    </div>
    <div class="regsuctxt">
      <div class="reginfo">
        <div class="intit1 mt40">恭喜您，注册成功</div>
        <div class="indes2 mt30">
          为了方便您更好的享受律观网给您提供的服务，建议你完善资料。
        </div>
        <div class="wszl mt30">点击完善资料</div>
      </div>
      <div class="xzinfo">
        <div class="xxbt">您可以有以下选择：</div>
        <div class="otherxzlist flex_start">
          <div class="otheritem">
            <div>
              <svg-icon icon-class="regzx" class="regicon" />
            </div>
            <div>在线咨询</div>
          </div>

          <div class="otheritem">
            <div>
              <svg-icon icon-class="regwt" class="regicon" />
            </div>
            <div>案件委托</div>
          </div>

          <div class="otheritem">
            <div>
              <svg-icon icon-class="regls" class="regicon" />
            </div>
            <div>找律师</div>
          </div>

          <div class="otheritem">
            <div>
              <svg-icon icon-class="regzs" class="regicon" />
            </div>
            <div>看知识</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  beforeMount() {
    this.$parent._data.currentactep = 3;
  },
};
</script>

<style lang="scss" scoped>
.logsig_3 {
  width: 1100px;
  padding: 40px 15px;
  margin-left: auto;
  margin-right: auto;
  background-color: #fff;
  .regsucbg {
    margin-right: 65px;
    img {
      width: 478px;
      height: 394px;
    }
  }
  .regsuctxt {
    align-self: flex-start;
    .reginfo {
      padding-bottom: 40px;
      border-bottom: 1px solid #eee;
      .intit1 {
        font-size: 24px;
        color: #333333;
        line-height: 24px;
      }
      .indes2 {
        font-size: 16px;
        color: #666666;
        line-height: 16px;
      }
      .wszl {
        cursor: pointer;
        width: 154px;
        height: 35px;
        text-align: center;
        line-height: 35px;
        background: #0057ff;
        border-radius: 3px;
        font-size: 16px;
        color: #ffffff;
      }
    }
    .xzinfo {
      padding-top: 30px;
      .xxbt {
        font-size: 16px;
        color: #bbbbbb;
      }
      .otherxzlist {
        margin-top: 30px;
        .otheritem {
          text-align: center;
          width: 115px;
          border-right: 1px solid #eee;
          font-size: 14px;
          color: #555555;
          cursor: pointer;
          .regicon {
            font-size: 38px;
            margin-bottom: 10px;
          }
          &:hover {
            color: #0057ff;
          }
          &:last-child {
            border-right: none;
          }
        }
      }
    }
  }
}
</style>